import { render, staticRenderFns } from "./SharingTab.vue?vue&type=template&id=b1202428&scoped=true"
import script from "./SharingTab.vue?vue&type=script&lang=js"
export * from "./SharingTab.vue?vue&type=script&lang=js"
import style0 from "./SharingTab.vue?vue&type=style&index=0&id=b1202428&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1202428",
  null
  
)

export default component.exports